module.exports = __webpack_public_path__ + "src/images/measurements/forearmCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/forearmCircumference.jpg
// module id = 1146
// module chunks = 0